export default `_bronsonComponent${Date.now() * Math.random()}`;
